import React from 'react';


const StepProgress = ({ currentStep, totalSteps }) => {
    const progress = Math.min((currentStep / totalSteps) * 100, 100);

    return (
        <div style={styles.container}>
            <div style={styles.text}>Step {currentStep} of {totalSteps}</div>
            <div style={styles.progressBarBackground}>
                <div
                    style={{
                        ...styles.progressBarFill,
                        width: `${progress}%`,
                    }}
                />
            </div>
        </div>
    );
};

const styles = {
    container: {
        width: '100%',
        maxWidth: '775px',
        margin: '10px auto 1.5rem auto',
        padding: '0 1rem',
        boxSizing: 'border-box'
    },
    text: {
        fontSize: '14px',
        fontWeight: 600,
        marginBottom: '0.5rem',
        color: '#333',
        textAlign: 'left',
    },
    progressBarBackground: {
        width: '100%',
        height: '10px',
        borderRadius: '5px',
        backgroundColor: '#e0e0e0',
        overflow: 'hidden',
    },
    progressBarFill: {
        height: '100%',
        backgroundColor: '#008939',
        borderRadius: '5px 0 0 5px',
        transition: 'width 0.4s ease-in-out',
    },
};

export default StepProgress;
